export default __webpack_public_path__ + "static/media/correct1.5458cbad.png";